import { UserAssignmentRole } from "./types";

export const districtRoles = [
  UserAssignmentRole.DATA_MANAGER,
  UserAssignmentRole.DISTRICT_OWNER,
  UserAssignmentRole.DISTRICT_LEADERSHIP,
];
